import MuiSpeedDial, { SpeedDialProps } from '@mui/material/SpeedDial';
import EDFab from '../Fab/EDFab';
import { themeColors } from '../ThemeProvider/AvenyThemeColors';
import { TouchRippleProps } from '@mui/material';

type IEDFabProps = Partial<React.ComponentProps<typeof EDFab>>;
type IMuiSpeedDialFabProps = NonNullable<SpeedDialProps['FabProps']>;

interface IProps extends Omit<SpeedDialProps, 'FabProps'> {
  glass?: boolean;
}

export const EDSpeedDial: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { glass, ...restProps } = props;

  const FabProps: IMuiSpeedDialFabProps & IEDFabProps = glass
    ? {
        glass: true,
        color: 'secondary',
        size: 'medium',
        TouchRippleProps: {
          sx: {
            color: themeColors.customGlass.buttonBackground,
          },
        } as Partial<TouchRippleProps>,
      }
    : {};

  const mergedFabProps = {
    component: EDFab,
    ...FabProps,
  } as SpeedDialProps['FabProps'];

  return <MuiSpeedDial {...restProps} FabProps={mergedFabProps} />;
};
